import {
  type OnboardingResumeSource,
  RETURNS_RESUME_ENTRY_STEP_ID,
} from "@redotech/redo-onboarding-api/resume-source";
import type { SaveProgressRpc } from "./rpc-client";

export async function persistReturnsResumeSource(options: {
  currentStepId: string;
  resumeSource: OnboardingResumeSource;
  rpcClient: SaveProgressRpc;
}): Promise<boolean> {
  const result = await options.rpcClient.saveProgress({
    productId: "returns",
    currentStepId: options.currentStepId,
    sourceStepId: RETURNS_RESUME_ENTRY_STEP_ID,
    stepData: { source: options.resumeSource },
    stepDataWriteMode: "set-if-absent",
  });
  return result.stepDataWritten;
}
